import {create} from 'zustand';
import {StatusModalStates} from '../../../components';

type PaymentStageStore = {
  stage: StatusModalStates;
  setStage: (stage: StatusModalStates) => void;
};

export const usePaymentStageStore = create<PaymentStageStore>(set => ({
  stage: StatusModalStates.IDLE,
  setStage: stage => set({stage}),
}));
